import { queryOptions, useQuery } from "@tanstack/react-query"
import * as overviewModel from "src/pages/study/overview/overview.model"
import { CACHE_TIME } from "src/pages/study/constants"
import { useRouteParams } from "@myvp/shared/src/hooks/use-route-params"
import { eproModuleRouteNames } from "src/pages/epro-module/epro-module.route-names"
import { QueryOptionsData } from "@myvp/shared/src/types"

export type StudyHomeMetrics = QueryOptionsData<typeof getStudyQueryOptions>

export const getStudyQueryOptions = (globalSponsorStudyId: string) =>
  queryOptions({
    queryKey: ["getStudyHomeMetrics", globalSponsorStudyId],
    queryFn: async () =>
      overviewModel.getStudyHomeMetrics(globalSponsorStudyId),
    staleTime: CACHE_TIME,
    gcTime: CACHE_TIME,
  })

export const useSponsorStudy = () => {
  const { globalSponsorStudyId } = useRouteParams(eproModuleRouteNames.studio)

  return useQuery(getStudyQueryOptions(globalSponsorStudyId))
}
